// extracted by mini-css-extract-plugin
export default {"scrollContainer":"scrollContainer--Nf4Db","list":"list--v8YRc","wrapper":"wrapper--fsIcz","item":"item--fcsKH"};